import React from 'react';
import * as XLSX from 'xlsx';

export default function RegistrationTable({ enrolments }) {
    const headers = [
        'Registration Date',
        'Registration Code',
        'First name',
        'Last name',
        'Email',
        'Address 1',
        'Address 2',
        'City',
        'Post code',
        'Country',
        'South Island',
        'Phone',
        'Ecclesia',
        'Age',
        'Date of birth',
        'Guardian',
        'Gender',
        'Baptised',
        'School year',
        'Tertiary student',
        'First aid certificate',
        'Dietary requirements',
        'Accommodation',
        'Tent mattresses',
        'Highchair or Portacot',
        'Arrival details',
        'Transport',
        'Subscribe to newsletter',
        'Capital fund',
        'Free will offering',
    ];

    const handleExport = () => {
        // Prepare the data
        const data = [
            headers,
            ...enrolments.map((enrolment) => [
                enrolment.registrationDate,
                enrolment.registrationCode,
                enrolment.firstName,
                enrolment.lastName,
                enrolment.email,
                enrolment.address1,
                enrolment.address2,
                enrolment.city,
                enrolment.postCode,
                enrolment.country,
                enrolment.southIsland,
                enrolment.phone,
                enrolment.ecclesia,
                enrolment.age,
                enrolment.dateOfBirth,
                enrolment.guardian,
                enrolment.gender,
                enrolment.baptised,
                enrolment.schoolYear,
                enrolment.tertiaryStudent,
                enrolment.firstAidCert,
                enrolment.dietaryRequirements,
                enrolment.accommodation,
                enrolment.tentMattresses,
                enrolment.highChairPortacot,
                enrolment.arrivalDetails,
                enrolment.transport,
                enrolment.subscribe,
                enrolment.capitalFund,
                enrolment.freeWill,
            ]),
        ];

        // Create workbook and worksheet
        const wb = XLSX.utils.book_new();
        const ws = XLSX.utils.aoa_to_sheet(data);

        // Add worksheet to workbook
        XLSX.utils.book_append_sheet(wb, ws, 'Attendees');

        // Generate Excel file and trigger download
        XLSX.writeFile(wb, 'enrolments.xlsx');
    };

    return (
        <>
            <div style={{ marginTop: '20px', marginBottom: '20px' }}>
                <button onClick={handleExport}>Export excel</button>
            </div>
            <table className="registrations-table">
                <tbody>
                    <tr>
                        {headers.map((header, index) => (
                            <th key={index}>{header}</th>
                        ))}
                    </tr>
                    {enrolments.map((enrolment, index) => (
                        <tr key={index}>
                            <td>{enrolment.registrationDate}</td>
                            <td>{enrolment.registrationCode}</td>
                            <td>{enrolment.firstName}</td>
                            <td>{enrolment.lastName}</td>
                            <td>{enrolment.email}</td>
                            <td>{enrolment.address1}</td>
                            <td>{enrolment.address2}</td>
                            <td>{enrolment.city}</td>
                            <td>{enrolment.postCode}</td>
                            <td>{enrolment.country}</td>
                            <td>{enrolment.southIsland}</td>
                            <td>{enrolment.phone}</td>
                            <td>{enrolment.ecclesia}</td>
                            <td>{enrolment.age}</td>
                            <td>{enrolment.dateOfBirth}</td>
                            <td>{enrolment.guardian}</td>
                            <td>{enrolment.gender}</td>
                            <td>{enrolment.baptised}</td>
                            <td>{enrolment.schoolYear}</td>
                            <td>{enrolment.tertiaryStudent}</td>
                            <td>{enrolment.firstAidCert}</td>
                            <td>{enrolment.dietaryRequirements}</td>
                            <td>{enrolment.accommodation}</td>
                            <td>{enrolment.tentMattresses}</td>
                            <td>{enrolment.highChairPortacot}</td>
                            <td>{enrolment.arrivalDetails}</td>
                            <td>{enrolment.transport}</td>
                            <td>{enrolment.subscribe}</td>
                            <td>{enrolment.capitalFund}</td>
                            <td>{enrolment.freeWill}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </>
    );
}
